export enum Device {
  Web = 1,
  PWA = 3,
  BrandWeb = 21,
  BrandPWA = 22,
  BrandNativeApp = 23,
}

export enum DeviceType {
  Web = 3,
  PWA = 4,
  NativeApp = 5,
}
